import {Filter, type FilterProps, type FilterProvider} from '@github-ui/filter'

import {getCustomPropertiesProviders, type PropertyDefinition} from './providers/custom-properties'
import {getAllDateProviders} from './providers/date'
import {LanguageStaticFilterProvider} from './providers/languages'
import {getAllNumberProviders} from './providers/number'
import {getAllStaticProviders} from './providers/static'

export type {PropertyDefinition}

interface Props extends Omit<FilterProps, 'providers' | 'sx'> {
  definitions: PropertyDefinition[]
  /**
   * Optional filter providers to override the default repository filter providers.
   * If not provided, all repository filter providers will be used.
   */
  providers?: FilterProvider[]
}

export function ReposFilter({definitions, providers, ...props}: Props) {
  const actualProviders: FilterProvider[] = providers || getDefaultProviders(definitions)

  return <Filter {...props} providers={actualProviders} />
}

function getDefaultProviders(definitions: PropertyDefinition[]): FilterProvider[] {
  return [
    ...getAllStaticProviders(),
    ...getAllNumberProviders(),
    ...getAllDateProviders(),
    ...getCustomPropertiesProviders(definitions),
    new LanguageStaticFilterProvider(),
  ]
}

try{ ReposFilter.displayName ||= 'ReposFilter' } catch {}